import FileAttachment from "./file-attachment";
import FileContent from "./file-content";
export default class File {
  constructor(fileAttachment, fileContent) {
    this.fileAttachment = fileAttachment;
    this.fileContent = fileContent;
  }
}